import React, {Component, createRef} from 'react';
import {connect} from 'react-redux';
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJExport from '../view/FJExport'
import FJExportHeader from "../view/FJExportHeader";
import FJExportResolution from "../view/FJExportResolution";
import FJExportProgress from "../view/FJExportProgress";
import FJExportSuccess from "../view/FJExportSuccess";
import FJExportIntroContainer from "./FJExportIntroContainer";
import FJQuestionMarkIcon from "../view/FJQuestionMark.icon";
import exportCheck from "../../../icon/export-check.svg";
import InlineSVG from "react-inlinesvg";
import tips from "../../../icon/tips.svg";
import FJClose from "../view/FJClose.icon";
import FJLocalStore from '../../../store/FJLocalStore'
import FJExportVideoAction from '../../../redux/action/FJExportVideo.action'
import FJConfig from "../../../config/FJConfig";
import FJGifOption from '../view/FJGifOption'
import FJEventConstant from "../../../constant/FJEventConstant";
import FJPaymentAction from "../../../redux/action/FJPayment.action";
import FJPrimaryButton from "../../../common/component/FJPrimaryButton";
import {FJExportPreviewAction} from "../../../redux/action/FJRoot.action";
import FJCanvasStore from "../../../store/FJCanvasStore";
import FJUtil from "../../../util/FJUtil";

const EXPORT_OPTION = 1;
const EXPORT_INTRO = 2;
const EXPORT_PROGRESS = 3;
const EXPORT_SUCCESS = 4;
const GIF_OPTION = 5;
const EXPORT_TYPE_VIDEO = 'EXPORT_TYPE_VIDEO'
const EXPORT_TYPE_GIF = 'EXPORT_TYPE_GIF'

class FJExportModalContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shouldMp4Animation: true,
      couldMp4Animation: false,
      shouldGifAnimation: true,
      couldGifAnimation: false,
      status: EXPORT_OPTION,
      isShow: false,
      exportType: EXPORT_TYPE_VIDEO,
      list: [{type: 'MP4', text: "MP4"}, {type: 'GIF', text: 'GIF'}],
    };
    this._header = createRef();
  }

  componentDidMount() {
    this._unsubscribe = window.FJEvent.subscribe(FJEventConstant.CHANGE_EXPORT_STATUS, this.changeStatus);
  }

  componentWillUnmount() {
    this._unsubscribe && this._unsubscribe();
  }

  /**
   * @description 切换输出分类
   * @param index
   * @private
   */
  _onChange = (index) => {
    let type = this.state.list[index].type;
    if (type === 'MP4') {
      if (this.state.status !== EXPORT_INTRO) {
        this.changeStatus(EXPORT_OPTION)
        this.setState({
          exportType: EXPORT_TYPE_VIDEO,
        });
      }
    } else if (type === 'GIF') {
      this.changeStatus(GIF_OPTION);
      this.setState({
        exportType: EXPORT_TYPE_GIF,
      });
    }
    this.props.disableIntro();
  };

  _renderHeader = () => {
    let {exportType, list, status} = this.state;
    let tagIndex = 0;
    let curList = exportType === EXPORT_TYPE_VIDEO && status !== EXPORT_OPTION ? [list[0]] : list;
    switch (exportType) {
      case EXPORT_TYPE_VIDEO:
        tagIndex = 0;
        break;
      case EXPORT_TYPE_GIF:
        tagIndex = 1;
        break;
      default:
    }
    return (
      <FJExportHeader onClose={this.closePanel}
                      ref={this._header}
                      tagIndex={tagIndex}
                      onTagChange={this._onChange}
                      isShow={status === EXPORT_OPTION || status === EXPORT_INTRO || status === GIF_OPTION}
                      list={curList}
      />
    );
  };

  _renderCloseIcon = () => {
    return <FJClose/>;
  };

  _renderTipIcon = (className) => {
    return <InlineSVG src={tips} element='div' className={className}/>;
  };

  _renderQuestionIcon = () => {
    return <FJQuestionMarkIcon/>
  };

  _renderCheckIcon = () => {
    return <InlineSVG src={exportCheck} element='div'/>
  };

  _renderPrimaryButton = (props) => {
    return <FJPrimaryButton {...props}/>
  };

  _renderResolution = () => {
    let {status, shouldMp4Animation} = this.state;
    let {qualitySelected, overLimitContents, ratioType, visible} = this.props;
    let {setResolution} = this.props;
    return (
      <FJExportResolution isShow={visible && status === EXPORT_OPTION}
                          shouldAnimation={shouldMp4Animation}
                          selectedResolution={qualitySelected}
                          ratioType={ratioType.replace('RATIO_', '').toLowerCase()}
                          levelBasicText={FJLocalStore._('basic')}
                          levelPlusText={FJLocalStore._('plus')}
                          nextText={FJLocalStore._('next')}
                          titleText={FJLocalStore._('choose-export-resolution')}
                          downloadLimitText={FJLocalStore._('download-with-intro')}
                          upgradeText={FJLocalStore._('upgrade-and-download')}
                          overLimitContents={overLimitContents}
                          onNext={() => this.next('normal')}
                          onChange={setResolution}
                          onUpgrade={this.onUpgrade}
                          onDownloadWithWaterMark={() => this.next('watermark')}
                          onRenderQuestionIcon={this._renderQuestionIcon}
                          onRenderCheckIcon={this._renderCheckIcon}
                          onRenderPrimaryButton={this._renderPrimaryButton}

      />
    );
  };

  _renderGifOption = () => {
    let {status, shouldGifAnimation} = this.state;
    let {duration} = this.props;
    return (
      <FJGifOption isShow={status === GIF_OPTION}
                   shouldAnimation={shouldGifAnimation}
                   gifOptionPath={FJConfig.iconPath}
                   title={FJLocalStore._('choose-export-resolution')}
                   qualityTitle={FJLocalStore._('better-quality')}
                   qualityDesc={FJLocalStore._('better-quality-desc')}
                   sizeTitle={FJLocalStore._('proper-size')}
                   sizeDesc={FJLocalStore._('proper-size-desc')}
                   exportText={FJLocalStore._('export')}
                   resolutionText={FJLocalStore._('resolution')}
                   fpsText={FJLocalStore._('fps')}
                   fpsExplainText={FJLocalStore._('fps-explain')}
                   customText={FJLocalStore._('custom')}
                   customResolutionText={FJLocalStore._('customize-your-resolution-fps')}
                   limitTipText={FJLocalStore._('gif-only-supports-long-output').replace('xxx', FJConfig.exportGifDurationLimit)}
                   disabled={duration > FJConfig.exportGifDurationLimit}
                   onExport={this._exportGif}
                   onRenderCheckIcon={this._renderCheckIcon}
                   onRenderQuestionIcon={this._renderQuestionIcon}
                   onRenderPrimaryButton={this._renderPrimaryButton}
      />
    );
  };

  _renderIntro = () => {
    let {status} = this.state;
    return (
      <FJExportIntroContainer onChangeStatus={this.changeStatus}
                              onBack={this.pre}
                              onExport={this._export}
                              onRenderPrimaryButton={this._renderPrimaryButton}
                              isShow={status === EXPORT_INTRO}/>
    );
  };

  _renderProgress = () => {
    let {status} = this.state;
    let {progress} = this.props;
    progress = progress > 1 ? 1 : progress;
    return (
      <FJExportProgress isShow={status === EXPORT_PROGRESS}
                        title={FJLocalStore._('please-wait-a-moment')}
                        note={FJLocalStore._('progress-note')}
                        onRenderIcon={this._renderTipIcon}
                        onRenderCloseIcon={this._renderCloseIcon}
                        onClose={this.closePanel}
                        progress={progress}
      />
    );
  };

  _renderResult = () => {
    let {status, exportType} = this.state;
    let {download, youtubeShareProgress, isYoutubeSharing, shareDropbox, shareYoutube} = this.props;
    let isVideoExport = exportType === EXPORT_TYPE_VIDEO;
    return (
      <FJExportSuccess isShow={status === EXPORT_SUCCESS}
                       title={isVideoExport ? FJLocalStore._('export-success') : FJLocalStore._('gif-successfully-exported')}
                       downloadTitle={FJLocalStore._("download-video-title")}
                       downloadBtnText={FJLocalStore._("downlaod-button-title")}
                       youtubeText={FJLocalStore._('share-your-video')}
                       uploadSuccessText={FJLocalStore._('uploaded-successfully')}
                       continueText={FJLocalStore._('continue-editing')}
                       dropBoxText={FJLocalStore._('dropbox-upload-button-title')}
                       isSharing={isYoutubeSharing}
                       sharingProgress={youtubeShareProgress}
                       couldUseYoutube={isVideoExport}
                       couldUseDropbox={isVideoExport}
                       onContinue={this.closePanel}
                       onDownload={download}
                       onClose={this.closePanel}
                       onUploadToDropBox={shareDropbox}
                       onShareToYoutube={shareYoutube}
      />
    );
  };

  /**
   * @description 进入intro界面
   * @param type
   */
  next = (type) => {
    const { qualitySelected, overLimitContents } = this.props;
    this.changeStatus(EXPORT_INTRO);
    switch (type) {
      case 'normal':
        FJUtil.ealog('timeline_export_resolution_page_next_click', {
          resolution: qualitySelected,
        });
        break;
      case 'watermark':
        FJUtil.ealog('timeline_export_with_watermark_click', {
          resolution: qualitySelected,
          limit: overLimitContents.join(','),
        })
        break;
      default:
    }
  };

  pre = () => {
    this.changeStatus(EXPORT_OPTION);
  };

  changeStatus = (status, done) => {
    const {couldMp4Animation, couldGifAnimation} = this.state;
    let _shouldMp4Animation = couldMp4Animation && status === EXPORT_OPTION;
    let _shouldGifAnimation = couldGifAnimation && status === GIF_OPTION;
    this.setState({
      status,
      couldMp4Animation: couldMp4Animation && !_shouldMp4Animation,
      couldGifAnimation: couldGifAnimation && !_shouldGifAnimation,
      shouldMp4Animation: _shouldMp4Animation,
      shouldGifAnimation: _shouldGifAnimation,
    }, () => {
      if (done) {
        done();
      }
      console.log(this.state.couldMp4Animation, this.state.couldGifAnimation, this.state.shouldMp4Animation, this.state.shouldGifAnimation,)
    });
  };

  closePanel = () => {
    let status = this.state.status;
    this.setState({
      status: EXPORT_OPTION,
      exportType: EXPORT_TYPE_VIDEO,
    });
    this.props.close(status);
  };

  onUpgrade = () => {
    const { upgrade, qualitySelected, overLimitContents } = this.props;
    upgrade('export');
    FJUtil.ealog('timeline_export_resolution_page_upgrade_click', {
      resolution: qualitySelected,
      limit: overLimitContents.join(','),
    })
  };

  _exportGif = (size, fps) => {
    this.changeStatus(EXPORT_PROGRESS, () => {
      this.props.startExportGif(size, fps);
    });
  };

  _export = (size) => {
    this.changeStatus(EXPORT_PROGRESS, () => {
      this.props.startExport(size);
    });
  };

  _onShown = () => {
    const {status} = this.state;
    this.setState({
      couldMp4Animation: status !== EXPORT_OPTION,
      shouldMp4Animation: status === EXPORT_OPTION,
      couldGifAnimation: status !== GIF_OPTION,
      shouldGifAnimation: status === GIF_OPTION,
    });
    setTimeout(() => {
      this._header.current.updateInfo();
    }, 150);

    FJUtil.ealog('timeline_export_resolution_page_visit');
  };

  _onHide = () => {
    FJCanvasStore.executeSync(FJCanvasStore.command.UNBIND_EXPORT_PREVIEW);
    window.FJEvent.dispatch(FJEventConstant.UPDATE_CANVAS_SIZE);
    this.setState({
      couldMp4Animation: true,
      couldGifAnimation: true,
      shouldMp4Animation: true,
      shouldGifAnimation: true,
    });
  }

  render() {
    let {visible} = this.props;
    return (
      <FJCommonModal visible={visible}
                     onShown={this._onShown}
                     onHide={this._onHide}
                     backgroundColor='#F6F7FA'>
        <FJExport isShow
                  onRenderHeader={this._renderHeader}
                  onRenderResolution={this._renderResolution}
                  onRenderIntro={this._renderIntro}
                  onRenderProgress={this._renderProgress}
                  onRenderResult={this._renderResult}
                  onRenderGifOption={this._renderGifOption}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    duration: state.timeline.duration,
    visible: state.exportVideo.isExportPanelShow,
    progress: state.exportVideo.exportProcess,
    qualitySelected: state.exportVideo.qualitySelected,
    isYoutubeSharing: state.exportVideo.isYoutubeSharing,
    youtubeShareProgress: state.exportVideo.youtubeShareProgress,
    ratioType: state.more.ratioType,
    overLimitContents: state.payment.overLimitContents,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    close: function (status) {
      dispatch(FJExportVideoAction.onClickCloseAction(status));
    },
    startExport: function (size) {
      dispatch(FJExportVideoAction.startExportAction(size))
    },
    startExportGif: function (size, fps) {
      dispatch(FJExportVideoAction.startExportGifAction(size, fps))
    },
    upgrade: function (source) {
      dispatch(FJPaymentAction.upgradeLevelAction(source));
    },
    setResolution: function (resolution) {
      dispatch(FJExportVideoAction.setResolutionAction(resolution));
    },
    download: function (resolution) {
      dispatch(FJExportVideoAction.onClickDownloadAction(resolution));
    },
    shareDropbox: function () {
      dispatch(FJExportVideoAction.shareDropboxAction());
    },
    shareYoutube: function () {
      dispatch(FJExportVideoAction.shareYoutubeAction());
    },
    disableIntro: function () {
      dispatch(FJExportPreviewAction.disableIntroAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJExportModalContainer);
